import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, {
    staticClass: "twin-metainfo-form"
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VRow, [!_vm.hideFields.includes('icon') ? _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "input_twin_title",
      "disabled": !_vm.twinCanBeEdited,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.enterTwinTitle'),
      "color": _vm.color,
      "rules": [_vm.rules.required],
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "twinObjectTitle",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.computedTwinObject.title,
      callback: function ($$v) {
        _vm.$set(_vm.computedTwinObject, "title", $$v);
      },
      expression: "computedTwinObject.title"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.titleDigitalTwinHint')))])], 1) : _vm._e(), !_vm.hideFields.includes('icon') ? _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm.isCreatedByTemplate ? _c(VTextField, {
    attrs: {
      "data-cy": "select_icon",
      "label": _vm.$i18n_t('Common.icon'),
      "disabled": "",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "required",
      "prepend-inner-icon": 'fal fa-' + _vm.twinObject.data.faIcon,
      "append-icon": "fa-sitemap"
    },
    model: {
      value: _vm.computedTwinObject.data.faIcon,
      callback: function ($$v) {
        _vm.$set(_vm.computedTwinObject.data, "faIcon", $$v);
      },
      expression: "computedTwinObject.data.faIcon"
    }
  }) : _c('core-icons', {
    attrs: {
      "faStyle": "light",
      "disabled": !_vm.twinCanBeEdited,
      "dense": ""
    },
    model: {
      value: _vm.computedTwinObject.data.faIcon,
      callback: function ($$v) {
        _vm.$set(_vm.computedTwinObject.data, "faIcon", $$v);
      },
      expression: "computedTwinObject.data.faIcon"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.iconDigitalTwinHint')) + "\n          ")])], 1) : _vm._e(), !_vm.hideFields.includes('type') ? _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VCombobox, {
    attrs: {
      "data-cy": "select_twin_type",
      "disabled": !_vm.twinCanBeEdited,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinType'),
      "items": _vm.twinTypes,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "return-object": false,
      "item-text": "text",
      "item-value": "value",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (props) {
        return [_vm._v(_vm._s(props.item.text) + " (" + _vm._s(props.item.value) + ")")];
      }
    }, {
      key: "selection",
      fn: function () {
        return [_vm._v(_vm._s(_vm.selectedTwinTypeText) + " (" + _vm._s(_vm.twinObject.data.type) + ")")];
      },
      proxy: true
    }], null, false, 3074209945),
    model: {
      value: _vm.computedTwinObject.data.type,
      callback: function ($$v) {
        _vm.$set(_vm.computedTwinObject.data, "type", $$v);
      },
      expression: "computedTwinObject.data.type"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinTypeHint')))])], 1) : _vm._e(), _vm.hasVisibleParent && !_vm.hideFields.includes('parent') ? _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-dtwin-finder', {
    attrs: {
      "objectFilter": _vm.parentSelectorFilter,
      "append-icon": _vm.isCreatedByTemplate ? 'fa-sitemap' : undefined,
      "disabled": !_vm.twinCanBeEdited,
      "readonly": _vm.isCreatedByTemplate,
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
      "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
      "tenantId": _vm.twinObject.tenantId,
      "sameTenant": "",
      "required": "",
      "hideDetails": ""
    },
    model: {
      value: _vm.computedTwinObject.parentId,
      callback: function ($$v) {
        _vm.$set(_vm.computedTwinObject, "parentId", $$v);
      },
      expression: "computedTwinObject.parentId"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.parentDigitalTwinHint')))])], 1) : _vm._e(), !_vm.hideFields.includes('scope') ? _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "input_twin_scope",
      "value": _vm.scopeDetailledName,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.scope'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "readonly": "",
      "disabled": _vm.isCreatedByTemplate,
      "append-icon": _vm.isCreatedByTemplate ? 'fa-sitemap' : undefined
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.scopeText')))])], 1) : _vm._e(), _vm.originalTitle !== _vm.get(_vm.twinObject, 'scope.name') && _vm.hasTwinManagePermission && _vm.twinCanBeEdited && !_vm.hideFields.includes('scope') && !_vm.hideFields.includes('scope-edit') ? _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-unlock-alt"
    },
    on: {
      "click": function ($event) {
        return _vm.createDigitalTwinScope();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinCreateOwnScope')) + "\n          ")]), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinCreateOwnScopeText')))])], 1) : _vm._e(), _vm.twinTemplate && !_vm.hideFields.includes('twinTemplate') ? _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "input_twin_template",
      "value": _vm.get(_vm.twinTemplate, 'title'),
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinTemplates.twinTemplate'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "disabled": ""
    }
  })], 1) : _vm._e(), !_vm.hideFields.includes('account') ? _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "value": _vm.account,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.deviceAccount'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "readonly": "",
      "disabled": _vm.isCreatedByTemplate,
      "append-icon": _vm.isCreatedByTemplate ? 'fa-sitemap' : undefined
    }
  })], 1) : _vm._e()], 1)], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [!_vm.hideFields.includes('description') ? _c(VRow, [_c(VCol, [_vm.markdownEdit ? _c(VCard, {
    staticClass: "elevation-0 v-card-text-area mdbox",
    attrs: {
      "outlined": ""
    }
  }, [_c(VCardText, [_c('markdown-it-vue-light', {
    attrs: {
      "content": _vm.twinObject.data.description || ''
    }
  })], 1)], 1) : _c(VCard, [_c(VTextarea, {
    attrs: {
      "data-cy": "input_twin_description",
      "disabled": !_vm.twinCanBeEdited,
      "label": _vm.$i18n_t('Common.description'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rows": "7",
      "hide-details": "auto",
      "clearable": ""
    },
    model: {
      value: _vm.computedTwinObject.data.description,
      callback: function ($$v) {
        _vm.$set(_vm.computedTwinObject.data, "description", $$v);
      },
      expression: "computedTwinObject.data.description"
    }
  })], 1)], 1)], 1) : _vm._e(), !_vm.hideFields.includes('description') ? _c(VSwitch, {
    staticClass: "switch-dense",
    attrs: {
      "disabled": !_vm.twinCanBeEdited,
      "label": _vm.$i18n_t('Common.mdeditor'),
      "color": _vm.color
    },
    model: {
      value: _vm.markdownEdit,
      callback: function ($$v) {
        _vm.markdownEdit = $$v;
      },
      expression: "markdownEdit"
    }
  }) : _vm._e(), !_vm.hideFields.includes('tags') ? [_c(VRow, [_c(VCol, [_c('core-tags', {
    attrs: {
      "tagListType": _vm.tagListType,
      "disabled": !_vm.twinCanBeEdited,
      "tags": _vm.get(_vm.twinObject, 'data.tags', []),
      "externalTags": _vm.get(_vm.deviceTemplate, 'deviceMeta.tags', []).concat(_vm.get(_vm.twinTemplate, 'data.tags', [])),
      "data-cy": "twin-tags"
    },
    on: {
      "update:tags": _vm.setTags
    }
  })], 1)], 1)] : _vm._e()], 2), !_vm.hideFields.includes('userrelations') ? _c(VCol, {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_vm.twinObject.tenantId && _vm.hasUserReadPermission ? _c('core-dtwin-user-relations', {
    attrs: {
      "disabled": !_vm.twinCanBeEdited,
      "twinDataRelations": _vm.twinObject.data && _vm.twinObject.data.userRelations || [],
      "scopeId": _vm.twinObject.scopeId
    },
    on: {
      "update": _vm.userRelationsUpdated
    }
  }) : _vm._e()], 1) : _vm._e(), !_vm.hideFields.includes('attachments') ? _c(VCol, {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_vm.twinObject.tenantId ? _c('core-dtwin-attachments', {
    attrs: {
      "disabled": !_vm.twinCanBeEdited,
      "attachments": _vm.twinObject.data && _vm.twinObject.data.attachments || [],
      "selectedAttachments": _vm.selectedAttachments
    },
    on: {
      "update": _vm.attachmentsUpdated,
      "image-selected": _vm.twinImageSelected,
      "image-deselected": _vm.twinImageDeselected
    },
    scopedSlots: _vm._u([{
      key: "additional",
      fn: function () {
        return [_c(VRow, {
          staticClass: "ma-0 pa-0"
        }, [_c(VCol, {
          attrs: {
            "cols": "12",
            "sm": "6"
          }
        }, [_vm.twinImages.length > 1 ? _c(VSelect, {
          attrs: {
            "items": _vm.twinImages,
            "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.backgroundImage'),
            "item-value": "id",
            "item-text": "name"
          },
          model: {
            value: _vm.computedTwinObject.data.twinImageId,
            callback: function ($$v) {
              _vm.$set(_vm.computedTwinObject.data, "twinImageId", $$v);
            },
            expression: "computedTwinObject.data.twinImageId"
          }
        }) : _vm._e()], 1), _vm.twinObject.data.twinImageId ? _c(VCol, {
          attrs: {
            "cols": "12",
            "sm": "6"
          }
        }, [_c(VCheckbox, {
          staticClass: "py-0 mt-0 mb-2",
          attrs: {
            "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.useImageInsteadMap'),
            "color": _vm.color,
            "hide-details": ""
          },
          on: {
            "change": function ($event) {
              return _vm.$emit('is-selectecd', _vm.itemIsSelected);
            }
          },
          model: {
            value: _vm.computedTwinObject.data.twinImagePreferOverMap,
            callback: function ($$v) {
              _vm.$set(_vm.computedTwinObject.data, "twinImagePreferOverMap", $$v);
            },
            expression: "computedTwinObject.data.twinImagePreferOverMap"
          }
        }), _c('p', {
          staticClass: "card-description my-0"
        }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.useImageInsteadMapText')) + "\n              ")])], 1) : _vm._e()], 1)];
      },
      proxy: true
    }], null, false, 2800182745)
  }) : _vm._e()], 1) : _vm._e(), !_vm.hideFields.includes('keyvalue') ? _c(VCol, {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('core-dtwin-key-value-editor', {
    attrs: {
      "twinObject": _vm.twinObject,
      "hasTwinEditPermission": _vm.hasTwinEditPermission,
      "deviceTemplate": _vm.deviceTemplate
    }
  })], 1) : _vm._e()], 1), !_vm.hideFields.includes('referenceIds') ? _c('core-dtwin-reference-ids', {
    attrs: {
      "value": _vm.twinObject['dynamical-data-routing-destination'] || [],
      "disabled": !_vm.hasTwinEditPermission,
      "keyLabel": _vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.key'),
      "valueLabel": _vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.value')
    },
    on: {
      "update": _vm.handleUpdate
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.referenceIds.headline')))]), _c('p', {
          staticClass: "card-description my-0 mb-2"
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.referenceIds.description')) + "\n      ")])];
      },
      proxy: true
    }], null, false, 594045514)
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };